<template>
  <div class="local-modal"
       :class="`${customClass} local-modal--${colour} local-modal--${direction} ${hiding ? 'local-modal--hiding' : ''}`"
       :style="`width: ${width}px; min-width: ${width}px`">
    <component :is="internalContentComponent" :component-data="componentData"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { compose, equals, is, path, pathOr, split, when } from 'ramda'
import Tether from 'tether'

const getStateValue = (prop) => path(['localModal', prop])

export default {
  name: 'LocalModal',
  data() {
    return {
      tether: null,
      hiding: false,
      internalContentComponent: null,
    }
  },
  computed: {
    ...mapState(
      {
        targetElement: getStateValue('targetElement'),
        contentComponent: getStateValue('contentComponent'),
        attachment: getStateValue('attachment'),
        targetAttachment: getStateValue('targetAttachment'),
        colour: getStateValue('colour'),
        width: getStateValue('width'),
        componentData: getStateValue('componentData'),
        customClass: getStateValue('customClass'),
      },
    ),
    direction() {
      return compose(
        when(is(Array), path([0])),
        when(compose(equals('middle'), path([0])), path([1])),
        split(' '),
        pathOr('', ['targetAttachment']),
      )(this)
    },
  },
  watch: {
    contentComponent() {
      if (this.contentComponent === null) {
        this.hiding = true
        setTimeout(() => {
          this.internalContentComponent = null
        }, 600)
      } else {
        this.internalContentComponent = this.contentComponent
      }
    },
  },
  created() {
    this.internalContentComponent = this.contentComponent
  },
  mounted() {
    this.tether = new Tether({
      element: this.$el,
      target: this.targetElement,
      attachment: this.attachment,
      targetAttachment: this.targetAttachment,
    })
  },
  beforeDestroy() {
    if (this.tether) {
      this.tether.destroy()
      this.tether = null
    }
  },
}
</script>
